'use strict';
require('../../modules/es.object.assign');
var path = require('../../internals/path');

module.exports = path.Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/object/assign.js
// module id = 578
// module chunks = 13